export var TABS_CLASS_PREFIX = 'Tabs';